import router from './../router'
import Vue from 'vue'
import Toasted from 'vue-toasted'
import VueCookie from 'vue-cookie'

Vue.use(Toasted)

const actions = {
  /**
   * [answerQuestion description]
   * @param  {[type]} commit [description]
   * @param  {[type]} answer [description]
   * @return {[type]}        [description]
   */
  answerQuestion({ commit, state }, answer) {
    if (answer.type == 'multiple') {
      let values = state.lead[answer.leadKey]
      let valueIndex = values.indexOf(answer.value)
      let valueExists = valueIndex > -1
      let noneIndex = values.indexOf('None')
      let noneExists = noneIndex > -1
      let valueIsNone = answer.value == 'None'

      // Remove NONE if selected but selected something else
      if (noneExists) {
        values.splice(noneIndex, 1)
      }
      if (valueIsNone) {
        values = []
      }
      // Remove from array if value exists
      if (valueExists) {
        values.splice(valueIndex, 1)
      }
      // Add to array if value doesn't exist
      if (!valueExists) {
        values.push(answer.value)
      }
      // Set new answers
      answer.value = values
    }

    commit('SET_LEAD_VALUE', answer)

    // Remove validation errors
    commit('REMOVE_ERRORS', answer.leadKey)
    if (answer.type !== 'input') {
      Vue.nextTick(() => {
        let questions = document.getElementsByClassName('scrollToItem')
        let currentQuestion = document.getElementById(answer.leadKey)
        let currentQuestionIndex = Array.prototype.indexOf.call(
          questions,
          currentQuestion
        )
        let nextQuestionIndex = currentQuestionIndex + 1
        let nextQuestion = questions.item(nextQuestionIndex)
        let canSelectMultiple =
          $(currentQuestion).find('.questionChoices.multiple').length > 0
        if (nextQuestionIndex < questions.length && !canSelectMultiple) {
          let nextQuestionOffset = nextQuestion.offsetTop
          $('html, body').animate(
            {
              scrollTop: nextQuestionOffset,
            },
            750
          )
        }
      })
    }
  },

  save({ state }) {
    return axios.post('/ajax/save', { store: state })
  },

  /**
   * [removeQuestionErrors description]
   * @param  {[type]} commit [description]
   * @param  {[type]} key    [description]
   * @return {[type]}        [description]
   */
  removeQuestionErrors({ commit }, key) {
    commit('REMOVE_QUESTION_ERRORS', key)
  },

  /**
   * [getQuestions description]
   * @param  {[type]} commit [description]
   * @return {[type]}        [description]
   */
  getQuestions({ commit }) {
    // AJAX call to load all questions
  },

  /**
   * [visibleFieldsValidated description]
   * @param  {[type]} commit [description]
   * @return {[type]}        [description]
   */
  visibleFieldsValidated({ commit, state }) {
    let questions = document.getElementsByClassName('hasValidation')
    let errors = {}

    for (var i = 0; i < questions.length; i++) {
      let question = questions[i]
      let leadKey = question.getAttribute('id')
      let answer = state.lead[leadKey]
      if (answer == null || answer == '') {
        errors[leadKey] = ['This field is required']
      }
    }

    if (Object.keys(errors).length > 0) {
      commit('ADD_ERRORS', errors)
      return false
    }

    return true
  },

  /**
   * [incrementSectionIndex description]
   * @return {[type]} [description]
   */
  incrementSectionIndex({ commit }) {
    commit('INCREMENT_SECTION_INDEX')
  },

  /**
   * [setSectionIndex description]
   * @param {[type]} commit [description]
   * @param {[type]} index  [description]
   */
  setSectionIndex({ commit }, index) {
    commit('SET_SECTION_INDEX', index)
  },

  /**
   * [selectProtectionLevel description]
   * @param  {[type]} commit [description]
   * @param  {[type]} level  [description]
   * @return {[type]}        [description]
   */
  selectProtectionLevel({ commit, state }, level) {
    // If protectionLevel already exists
    if (state.lead.protectionLevel) {
      mixpanel.track('switchLevel', {
        currentLevel: state.lead.protectionLevel,
        selectedLevel: level,
      })
    }
    commit('SET_LEAD_VALUE', {
      leadKey: 'protectionLevel',
      value: level,
    })
    // router.push('/automation')
  },

  /**
   * [applyLeadBindingsFromStorage description]
   * @param  {[type]} commit [description]
   * @param  {[type]} state  [description]
   * @param  {[type]} lead   [description]
   * @return {[type]}        [description]
   */
  applyLeadBindingsFromStorage({ commit, state }, lead) {
    commit('APPLY_LEAD_BINDINGS_FROM_STORAGE', lead)
  },

  /**
   * [getEssentialSystem description]
   * @param  {[type]} commit [description]
   * @param  {[type]} state  [description]
   * @return {[type]}        [description]
   */
  getEssentialSystem({ commit, state }) {
    axios.get('/ajax/equipment/essential').then((res) => {
      let essential = res.data
      commit('SET_ESSENTIAL_SYSTEM', essential)
    })
  },

  /**
   * [getProtectionLevelWarnings description]
   * @param  {[type]} commit [description]
   * @return {[type]}        [description]
   */
  getProtectionLevelWarnings({ commit }) {
    axios.get('/ajax/logic/protection-level-warnings').then((res) => {
      let warnings = res.data
      commit('SET_PROTECTION_LEVEL_WARNINGS', warnings)
    })
  },

  /**
   * [dismissProtectionLevelWarning description]
   * @param  {[type]} commit [description]
   * @param  {[type]} index  [description]
   * @return {[type]}        [description]
   */
  dismissProtectionLevelWarning({ commit }, index) {
    commit('DISMISS_PROTECTION_LEVEL_WARNING', index)
  },

  /**
   * [dismissProtectionLevelWarning description]
   * @param  {[type]} commit [description]
   * @param  {[type]} index  [description]
   * @return {[type]}        [description]
   */
  dismissProtectionLevelWarnings({ commit }) {
    commit('DISMISS_PROTECTION_LEVEL_WARNINGS')
  },

  /**
   * [toggleModal description]
   * @param  {[type]} commit [description]
   * @return {[type]}        [description]
   */
  toggleModal({ commit }) {
    commit('TOGGLE_MODAL')
  },

  /**
   * [addAreaOfConcern description]
   * @param {[type]} commit [description]
   * @param {[type]} state  [description]
   * @param {[type]} area   [description]
   */
  addAreaOfConcern({ commit, state }, area) {
    commit('ADD_AREA_OF_CONCERN', area)

    let secured = area.equipmentOptionChosen !== ''
    let securedText = secured ? 'secured' : 'not secured'
    let equipmentAddedText = () => {
      if (secured) {
        let equipment = area.equipmentOptions[area.equipmentOptionChosen]
        return `${equipment.item.name} added`
      }
      return 'No equipment added'
    }

    let template = `
            <div class="toast-areaAdded">
                <div class="toast-icon">
                    <img src="/img/shield-checkmark.png" />
                </div>
                <div class="toast-content">
                    <div><strong>${area.name} ${securedText}</strong></div>
                    <div>${equipmentAddedText()}</div>
                </div>
            </div>
        `

    Vue.toasted.show(template, {
      position: 'bottom-left',
      className: 'toast',
      duration: 5000,
    })

    let mixpanelData = {
      P_AOC_roomType: area.name,
      P_AOC_isAccessible: area.accessibleFromGroundFloor,
      P_AOC_windowCount: area.windowsInput || area.windows,
      P_AOC_windowOpenCount: area.windowsThatOpenInput || area.windowsThatOpen,
      P_AOC_equipment: area.equipmentOptionChosen,
    }
    mixpanel.track('addedAreaOfConcern', mixpanelData)
  },

  /**
   * [updateAreaOfConcern description]
   * @param  {[type]} commit        [description]
   * @param  {[type]} areaOfConcern [description]
   * @return {[type]}               [description]
   */
  updateAreaOfConcern({ commit }, areaOfConcern) {
    if (areaOfConcern.windows === 4) {
      areaOfConcern.windowsInput = 4
    }
    if (areaOfConcern.windowsThatOpen === 4) {
      areaOfConcern.windowsThatOpenInput = 4
    }
    commit('UPDATE_AREA_OF_CONCERN', areaOfConcern)
  },

  editAreaOfConcern({ commit, state }, area) {
    let id = area.id
    let areas = state.lead.areasOfConcern
    let index = areas.findIndex((area) => area.id === id)
    if (index > -1) {
      areas[index] = area
      commit('UPDATE_AREAS_OF_CONCERN', areas)
    }
  },

  /**
   * [expandAreaOfConcern description]
   * @param  {[type]} commit [description]
   * @param  {[type]} index  [description]
   * @return {[type]}        [description]
   */
  expandAreaOfConcern({ commit, state }, index) {
    commit('EXPAND_AREA_OF_CONCERN', index)
  },

  closeAreaOfConcern({ commit }, index) {
    commit('CLOSE_AREA_OF_CONCERN', index)
  },

  expandGuarantee({ commit, state }, index) {
    commit('EXPAND_GUARANTEE', index)
  },

  closeGuarantee({ commit }, index) {
    commit('CLOSE_GUARANTEE', index)
  },

  deleteAreaOfConcern({ commit, dispatch, state }, index) {
    let area = { ...state.lead.areasOfConcern[index] }

    commit('DELETE_AREA_OF_CONCERN', index)

    let template = `<div class="toast-areaAdded">
                <div class="toast-icon">
                    <img src="/img/shield-checkmark.png" />
                </div>
                <div class="toast-content">
                    <div><strong>${area.name}</strong></div>
                    <div>Successfully deleted</div>
                </div>
            </div>
        `
    Vue.toasted.show(template, {
      position: 'bottom-left',
      duration: 5000,
    })

    dispatch('save')
  },

  getTrueAdvice({ commit, state, dispatch }) {
    axios.post('/ajax/true-advice', state).then((res) => {
      let trueAdvice = res.data
      dispatch('getPrice')
      commit('SET_TRUE_ADVICE', trueAdvice)
    })
  },

  getPrice({ commit, state }) {
    let essential = state.system.essential
    let additional = state.system.additional

    let essentialPrice = 0
    let additionalPrice = 0

    for (var i = 0; i < essential.length; i++) {
      let price = essential[i].item.price
      essentialPrice += price
    }

    for (var i = 0; i < additional.length; i++) {
      let price = additional[i].item.price
      additionalPrice += price
    }

    let total = essentialPrice + additionalPrice
    total = total.toLocaleString('en')

    commit('SET_SYSTEM_PRICE', total)
  },

  setHeaderShadow({ commit }, bool) {
    commit('SET_HEADER_SHADOW', bool)
  },

  closeAreasOfConcern({ commit, state }) {
    let areas = state.lead.areasOfConcern
    let closedAreas = areas.map((area) => {
      let o = area
      o.expanded = false
      return o
    })
    commit('UPDATE_AREAS_OF_CONCERN', closedAreas)
  },

  updateSystem({ commit, state, dispatch }) {
    return axios
      .post('/ajax/system', { lead: state.lead, system: state.system })
      .then((res) => {
        console.log(res.data)
        let plans = res.data.monitoringPlans
        let cookieOptions = { expires: 7 }
        let plansString = JSON.stringify(plans)
        VueCookie.set('monitoring_plans', plansString, cookieOptions)
        commit('UPDATE_SYSTEM', res.data)
      })
  },

  incrementAocSectionIndex({ commit }) {
    commit('INCREMENT_AOC_SECTION_INDEX')
  },

  decrementAocSectionIndex({ commit }) {
    commit('DECREMENT_AOC_SECTION_INDEX')
  },

  setAocSectionIndex({ commit }, index) {
    commit('SET_AOC_SECTION_INDEX', index)
  },

  resolveAdvice({ commit, state }, payload) {
    console.log(payload)
  },

  selectMonitoringPlan({ commit, state }, id) {
    let plans = state.system.monitoringPlans
    let updated = plans.map((plan) => {
      plan.selected = plan.id === id
      return plan
    })

    commit('SET_MONITORING_PLANS', updated)
  },

  toggleEquipmentExpanded({ commit, state }, payload) {
    console.log(payload)
    commit('TOGGLE_EQUIPMENT_EXPANDED', payload)
  },

  toggleHelpEquipmentExpanded({ commit, state }, id) {
    let id_map = state.equipment.map((e) => e.id)
    let index = id_map.indexOf(id)
    commit('TOGGLE_HELP_EQUIPMENT_EXPANDED', index)
  },

  removeAutomationInterest({ commit, state }, interest) {
    let interests = state.lead.automationInterests
    let indexToRemove = interests.indexOf(interest)
    interests.splice(indexToRemove, 1)
    commit('UPDATE_AUTOMATION_INTERESTS', interests)
  },

  removeAdditionalThreat({ commit, state }, interest) {
    let interests = state.lead.additionalThreats
    let indexToRemove = interests.indexOf(interest)
    interests.splice(indexToRemove, 1)
    commit('SET_ADDITIONAL_THREATS', interests)
  },

  wantsMoreAutomation({ commit, state }, key) {
    commit('WANTS_MORE_AUTOMATION', key)
  },

  cancelMoreAutomation({ commit, state }, key) {
    commit('CANCEL_MORE_AUTOMATION', key)
  },

  getEquipmentItems({ commit }, expandedOnLoad) {
    return axios.get('/ajax/equipment').then((res) => {
      let equipment = res.data
      equipment = equipment.map((e) => {
        return { ...e, expanded: e.name == expandedOnLoad }
      })
      commit('SET_EQUIPMENT', equipment)
    })
  },

  getMonitoringPlans({ commit }, expandedOnLoad) {
    return axios.get('/ajax/system/monitoring-plans').then((res) => {
      let equipment = res.data
      // equipment = equipment.map((e) => {
      //   return {...e, expanded: e.name == expandedOnLoad}
      // })
      commit('SET_MONITORING_PLANS', equipment)
    })
  },

  updateName({ commit }, name) {
    commit('UPDATE_NAME', name.target.value)
  },

  updateEmail({ commit }, email) {
    commit('UPDATE_EMAIL', email.target.value)
  },

  toggleEditHomeVisibility({ commit }) {
    commit('TOGGLE_EDIT_HOME_VISIBILITY')
  },

  getEnvironmentalRecommendations({ commit, state }) {
    axios
      .post('/ajax/environmental-recommendations', {
        assessment: state.lead,
      })
      .then((res) => {
        let recommendations = res.data
        let fireCount = recommendations.smokeCommunicators.length
        let coCount = recommendations.carbonMonoxideDetectors.length
        const FIRE = {
          key: 'Fire',
          value: fireCount,
        }

        const CARBON_MONOXIDE = {
          key: 'CarbonMonoxide',
          value: coCount,
        }
        if (state.environmentalRecommendations.Fire === 0) {
          commit('SET_ENVIRONMENTAL_RECOMMENDATION_QUANTITY', FIRE)
        }
        if (state.environmentalRecommendations.CarbonMonoxide === 0) {
          commit('SET_ENVIRONMENTAL_RECOMMENDATION_QUANTITY', CARBON_MONOXIDE)
        }
      })
  },

  setInterestedEquipmentQty({ commit, state }, { key, qty }) {
    let quantities = state.lead.automationQuantities
    quantities[key] = qty
    commit('SET_EQUIPMENT_QUANTITIES', quantities)
  },

  addFireProtection({ commit, state, dispatch }) {
    let additionalThreats = state.lead.additionalThreats
    additionalThreats.push('Fire')
    commit('SET_ADDITIONAL_THREATS', additionalThreats)
    dispatch('updateSystem')
  },

  selectMonitoringPlanFrequency({ commit }, frequency) {
    commit('SET_MONITORING_PLAN_FREQUENCY', frequency)
  },

  toggleMonitoringFrequencyVisible({ commit }) {
    commit('TOGGLE_MONITORING_FREQUENCY_VISIBLE')
  },

  selectPaymentMethod({ commit }, option) {
    console.log(option)
    commit('SET_PAYMENT_METHOD', option)
  },

  setPlace({ commit }, place) {
    commit('SET_PLACE', place)
  },

  updateOrder({ commit }, order) {
    commit('UPDATE_ORDER', order)
  },

  restrictToUnsignedInteger(context, payload) {
    const event = payload.event
    const length = payload.length || null
    let value = event.target.value
    var key = event.keyCode || event.which
    let isZero = key === 48
    let isOneToNine = key > 48 && key < 58
    let isDelete = key === 46
    let isBackspace = key === 8
    let isEnter = key === 13
    let isNumber = isZero || isOneToNine
    let validKeys = isZero || isOneToNine || isDelete || isBackspace || isEnter

    if (value) {
      if (value.length >= length && isNumber) {
        event.preventDefault()
      }
      if (validKeys) {
        return
      }
      event.preventDefault()
    }

    if (!value) {
      if (isOneToNine || isDelete || isBackspace) {
        return
      }
      event.preventDefault()
    }
  },

  toggleSlideout({ commit }) {
    commit('TOGGLE_SLIDEOUT')
  },

  closeSlideout({ commit }) {
    commit('CLOSE_SLIDEOUT')
  },

  handleDuplicateArea({ commit, state, dispatch }, area) {
    let duplicates = state.lead.areasOfConcern.filter(
      (a) => a.name === area.name
    )
    dispatch('updateAreaOfConcern', area).then(() => {
      if (duplicates.length > 0) {
        dispatch('setAocSectionIndex', -2)
      }
    })
    return duplicates
  },

  async checkBusinessHours({ commit }) {
    const res = await axios.get('/ajax/check-business-hours')
    commit('SET_BUSINESS_HOURS', res.data)
  },

  askAboutAsapInstall() {
    Intercom(
      'showNewMessage',
      "I'm interested in the next available installation date."
    )
    setTimeout(() => {
      const intercomFrame = $('.intercom-messenger-frame')
      const iFrameContents = intercomFrame.contents().contents()
      const sendButton = iFrameContents.find('.intercom-composer-send-button')
      sendButton.click()
      mixpanel.track('checkedInstallAvailability')
    }, 1000)
  },

  toggleTalkWithGuideVisible({ commit, state }) {
    if (!state.talkWithGuideVisible) {
      mixpanel.track('openedTalkWithGuide')
      gtag('event', 'conversion', {
        send_to: 'AW-879819493/NFUuCP-AmYMBEOX1w6MD',
      })
    }
    commit('toggleTalkWithGuideVisible')
  },

  showChat() {
    Intercom('show')
  },

  setAddressFormatted({ commit }, address) {
    commit('SET_ADDRESS_FORMATTED', address)
  },

  setCartItem({ commit, state, dispatch }, item) {
    let cart = [...state.cart]

    let cartItemIndex = cart.findIndex((cartItem) => cartItem.id === item.id)

    let cartItemExists = cartItemIndex > -1

    // Add to cart
    if (cartItemExists && item.quantity > 0) {
      cart[cartItemIndex].quantity = item.quantity
    }

    // Remove from cart
    if (cartItemExists && item.quantity < 1) {
      cart.splice(cartItemIndex, 1)
    }

    if (!cartItemExists && item.quantity > 0) {
      cart.push(item)
    }

    if (!cartItemExists && item.quantity < 1) {
      return
    }

    return commit('SET_CART', cart)
  },
}

export default actions
